import React from 'react';
import gql from 'graphql-tag';
import { SignalsData } from '../schemas/rql';
import ListingNudge from './discovery/listing_nudge';
import { RCTooltip } from '@reverbdotcom/cadence/components';

export const ICON_HEIGHT_TINY = 20;
export const ICON_HEIGHT_REGULAR = 34;

export const SignalsFragment = gql`
  fragment SignalsData on Listing {
    _id
    id
    signals: signals (input: { groups: [ITEM_PAGE_WHY_TO_BUY, ITEM_PAGE_NUDGES, ITEM_PAGE_WHY_REVERB] }) {
      name
      group
      title
      subtitle
      link {
        text
        url
      }
      icon
      tooltipText
    }
  }
`;

export function Item2WhyReverbSignals({ listing }: SignalsProps) {
  const signals = listing.signals?.filter(signal => signal.group === 'ITEM_PAGE_WHY_REVERB');

  if (!signals?.length) { return null; }

  return (
    <div className="item2__sidebar-module item2__sidebar-module--shaded">
      {signals.map(signal => {
        return <SignalDisplay signal={signal} inline={false} key={signal.name} />;
      })}
    </div>
  );
}

export function Item2NudgeSignals({ listing }: SignalsProps) {
  const signals = listing.signals?.filter(signal => signal.group === 'ITEM_PAGE_NUDGES');

  if (!signals?.length) { return null; }

  return (
    <div className="item2__sidebar-module">
      {signals.map(signal => {
        return <SignalDisplay signal={signal} inline={false} key={signal.name} />;
      })}
    </div>
  );
}

interface SignalsProps {
  listing: SignalsData.Fragment
}

export function Item2WhyToBuySignals({ listing }: SignalsProps) {
  const signals = listing.signals?.filter(signal => signal.group === 'ITEM_PAGE_WHY_TO_BUY');

  if (!signals?.length) { return null; }

  return (
    <div className="mtb-1">
      {signals.map(signal => {
        return <SignalDisplay signal={signal} inline key={signal.name} />;
      })}
    </div>
  );
}

interface Signal {
  name?: string,
  group?: string,
  title?: string,
  subtitle?: string,
  tooltipText?: string,
  link?: {
    text?: string,
    url?: string
  },
  icon?: string
}

function SignalDisplay({ signal, inline }: { signal: Signal, inline: boolean }) {
  if (!signal.name || !signal.icon) {
    return null;
  }

  const getIconSvg = function () {
    const iconHeight = inline ? ICON_HEIGHT_TINY : ICON_HEIGHT_REGULAR;
    return (
      <svg height={iconHeight}>
        <image href={signal.icon} height={iconHeight} />
      </svg>
    );
  };

  const subtitle = signal.subtitle && signal.tooltipText ?
    <RCTooltip text={signal.tooltipText} type="underline">
      {signal.subtitle}
    </RCTooltip> :
    <>{signal.subtitle}</>;

  const title = !signal.subtitle && signal.tooltipText ?
    <RCTooltip text={signal.tooltipText} type="underline">
      {signal.title}
    </RCTooltip> :
    <>{signal.title}</>;

  return (
    <ListingNudge
      title={title}
      subtitle={subtitle}
      linkText={signal.link?.text}
      linkUrl={signal.link?.url}
      inline={inline}
      icon={getIconSvg()}
      key={signal.title}
    />
  );
}
